__turbopack_context__.v({
  "section": "SectionWrapper-module-scss-module__3ibNNa__section",
});
